module.exports = __webpack_public_path__ + "img/simon.6cd4d597.jpg";